import actionTypes from '../constants/action-types';

const siteData = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_DATA:
      return action.payload.siteData;
    case actionTypes.UPDATE_SITE_DATA:
      return {
        ...state,
        ...action.payload.siteData,
      };
    default:
      return state;
  }
};

export default siteData;
